export default "__VITE_ASSET__C0j5H2eJ__"